import React, {Component} from 'react'
import confirmDialog from "../../../components/dialog/ConfirmDialog";
import ValidationUtil from "../../../components/form/validator/ValidationUtil";
import RemotingService from "../../../services/remoting-service/RemotingService";
import {TextInput, Wizard} from "../../../components";
import FormField from "../../../components/form/FormField";
import SignatureInput from "../../../components/signature-input/SignatureInput";
import DateUtil from "../../../utils/DateUtil";
import FormLanguages from "../enum/FormLanguages";
import moment from "moment";
import {isMinor} from "../../patient/Patient";
import SignatureDisplay from '../../../components/signature-input/SignatureDisplay';
import PsychologyFormTextEnum from '../enum/PsychologyFormTextEnum';
import ClinicLogo from "../../../layout/ClinicLogo";

export default class PublicPsychologyConsentForm extends Component {
    constructor(props) {
        super(props);
        this.formFields = [];
    }

    createHeader = (form) => {
        const { language } = this.props;
        const selectedLanguage = language || FormLanguages.ENGLISH.name;
        const textEnum = PsychologyFormTextEnum;

        return <div style={{ padding: "0px 20px 0px 20px" }}>
            <div className="row text-left">
                <div className="col-12 no-padding">
                    <ClinicLogo/>
                </div>
            </div>
            <div className="row">
                <div className="col-12 text-center no-padding" style={{ fontSize: 20, fontWeight: "bold" }}>
                    {textEnum.Form_Title[selectedLanguage]}
                </div>
            </div>
            <div className="row" style={{ fontSize: 11 }}>
                <div className="col-4 text-left no-padding">
                    <b>{textEnum.Patient_Name[selectedLanguage]}: </b> {form.patientFullName}
                </div>
                <div className="col-4 text-center no-padding">
                    <b>{textEnum.MRN[selectedLanguage]}: </b> {form.patientMrn}
                </div>
                <div className="col-4 text-right no-padding">
                    <b>{textEnum.DOB[selectedLanguage]}: </b> {DateUtil.formatDate(form.patientDOB)}
                </div>
            </div>
        </div>
    };

    fieldChanged = (fieldName, value) => {
        this.props.form[fieldName] = value;
        this.forceUpdate();
    };

    close = () => {
        confirmDialog(
            'Confirmation',
            'Are you sure you want to close this form? All input will be lost.',
            this.props.close);
    };

    pushFormFieldRef = (ref) => this.formFields.push(ref);

    submitForm = () => {
        if (ValidationUtil.checkWithNotification(this.formFields)) {
            const { consentFormCode: code, form, language } = this.props;

            RemotingService.postRemoteCall(`api/public/consent-form/code/${code}/psychology-consent-form`, form);
            this.props.onFormSubmit(form);
        }
    };

    /**
     * Get patient name safely handling null or undefined values
     * @param {Object} form - Form object containing patient information
     * @returns {string} - Patient name or empty string if not available
     */
    getPatientName = (form) => {
        return form && form.patientFullName ? form.patientFullName : '';
    }

    getPatientDOB = (form) => {
        return form && form.patientDOB ? form.patientDOB : null;
    }

    /**
     * Get localized text based on the current language
     * @param {string} key - The key to look up in the text enum
     * @returns {string} - The localized text
     */
    getLocalizedText = (key) => {
        const { language } = this.props;
        const selectedLanguage = language || FormLanguages.ENGLISH.name;
        return PsychologyFormTextEnum[key] ? PsychologyFormTextEnum[key][selectedLanguage] : '';
    }

    render() {
        // Reset formFields at start of render to collect fresh refs from child components
        this.formFields = [];

        const form = this.props.form;

        const selectedLanguage = this.props.language || FormLanguages.ENGLISH.name;
        const enumLabel = selectedLanguage === FormLanguages.ARABIC.name ? "nameInArabic" : "name";

        const patientName = this.getPatientName(form);
        const isPatientMinor = isMinor(this.getPatientDOB(form), 'KUWAIT');

        return (
            <Wizard
                show={true} fullScreen
                footerStyle={{ backgroundColor: '#f5f5f5' }}
                buttonStyle={{ backgroundColor: '#84BE56', border: 'none' }}
                header={this.createHeader(form)}
                close={this.close}
                onSubmit={this.submitForm}>

                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}>
                    <div style={{ margin: "20px 20px 20px 20px" }}>
                        <p>
                            {this.getLocalizedText('Treatment_Consideration')}
                        </p>

                        <p>{this.getLocalizedText('Understanding')}<br />
                            <ul>
                                <li>
                                    <p>
                                        {this.getLocalizedText('Understanding_Point1')}
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {this.getLocalizedText('Understanding_Point2')}
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {this.getLocalizedText('Understanding_Point3')}
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {this.getLocalizedText('Understanding_Point4')}
                                        <ul>
                                            <li>
                                                <p>
                                                    {this.getLocalizedText('Understanding_Point4_1')}
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    {this.getLocalizedText('Understanding_Point4_2')}
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    {this.getLocalizedText('Understanding_Point4_3')}
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    {this.getLocalizedText('Understanding_Point4_4')}
                                                </p>
                                            </li>
                                        </ul>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {this.getLocalizedText('Understanding_Point5')}
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {this.getLocalizedText('Understanding_Point6')}
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {this.getLocalizedText('Understanding_Point7')}
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {this.getLocalizedText('Understanding_Point8')}
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {this.getLocalizedText('Understanding_Point9')}
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {this.getLocalizedText('Understanding_Point10')}
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {this.getLocalizedText('Understanding_Point11')}
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {this.getLocalizedText('Understanding_Point12')}
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {this.getLocalizedText('Understanding_Point13')}
                                    </p>
                                </li>
                            </ul>
                        </p>
                    </div>
                </Wizard.Page>

                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => {
                        this.formFields = [];
                    }}>
                    <div style={{ margin: "20px 20px 20px 20px" }}>
                        <p><b>{this.getLocalizedText('Psychology_Data_Collection_Header')}</b><br />
                        </p>
                        <p>{this.getLocalizedText('Psychology_Data_Collection_Information')}<br />
                        </p>
                        <p>{this.getLocalizedText('Psychology_Data_Collection_Purpose')}<br />
                        </p>
                        <p>{this.getLocalizedText('Psychology_Data_Protection_Header')}<br />
                            <ul>
                                <li>
                                    <p>
                                        {this.getLocalizedText('Psychology_Data_Protection_Point1')}
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {this.getLocalizedText('Psychology_Data_Protection_Point2')}
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {this.getLocalizedText('Psychology_Data_Protection_Point3')}
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {this.getLocalizedText('Psychology_Data_Protection_Point4')}
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {this.getLocalizedText('Psychology_Data_Protection_Point5')}
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {this.getLocalizedText('Psychology_Data_Protection_Point6')}
                                    </p>
                                </li>
                            </ul>
                        </p>
                        <p>{this.getLocalizedText('Psychology_Data_Sharing')}<br />
                        </p>
                        <p>{this.getLocalizedText('Psychology_Marketing')}<br />
                        </p>
                    </div>
                </Wizard.Page>

                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div style={{ margin: "20px 20px 20px 20px" }}>
                        <p>{this.getLocalizedText('Psychology_Patient_Rights_Header')}<br />
                            <ul>
                                <li>
                                    <p>
                                        {this.getLocalizedText('Psychology_Patient_Rights_Point1')}
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {this.getLocalizedText('Psychology_Patient_Rights_Point2')}
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {this.getLocalizedText('Psychology_Patient_Rights_Point3')}
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {this.getLocalizedText('Psychology_Patient_Rights_Point4')}
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {this.getLocalizedText('Psychology_Patient_Rights_Point5')}
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        {this.getLocalizedText('Psychology_Patient_Rights_Point6')}
                                    </p>
                                </li>
                            </ul>
                        </p>
                        <p><b>{this.getLocalizedText('Psychology_Questions_Concerns')}</b><br />
                            {this.getLocalizedText('Psychology_Questions_Concerns_Description')}
                        </p>
                        <p><b>{this.getLocalizedText('Psychology_Complaints_Header')}</b><br />
                            {this.getLocalizedText('Psychology_Complaints_Description')}<br />
                            {this.getLocalizedText('Psychology_Complaints_DHA')}<br />
                        </p>
                    </div>
                </Wizard.Page>

                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div style={{ margin: "20px 20px 20px 20px" }}>

                        <div style={{ border: "1px solid #000000", margin: "10px 0px" }}>
                            <div style={{ margin: "10px 15px" }}>
                                <p><b>{this.getLocalizedText('Psychology_Patient_Responsibility')}</b>
                                </p>
                                <p><b>{this.getLocalizedText('Psychology_Final_Acknowledgment')}</b>
                                </p>
                                <p><b>{this.getLocalizedText('Psychology_Data_Understanding')}</b>
                                </p>
                            </div>
                        </div>

                        <div className="container">
                            <div className="row">
                                <div className="col-md-3 dim14-form-label">
                                    {this.getLocalizedText('Date')}
                                </div>
                                <div className="col-md-3 dim14-base-input">
                                    {": " + moment(new Date(form.patientDate)).format('MMMM DD, YYYY')}
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-3 dim14-form-label">
                                    {this.getLocalizedText('Patient_Name')}
                                </div>
                                <div className="col-md-3 dim14-base-input">
                                    {": " + patientName}
                                </div>
                                <div className="col-md-3 dim14-form-label">
                                    {this.getLocalizedText('Provider_Name')}
                                </div>
                                <div className="col-md-3 dim14-base-input">
                                    <TextInput value={form.providerName} disabled />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-3 dim14-form-label">
                                    {this.getLocalizedText('Print_Name')}
                                </div>
                                <div className="col-md-3 dim14-base-input">
                                    <FormField ref={formField => this.pushFormFieldRef(formField)}
                                        disabled={!isPatientMinor}
                                        required requiredMessage={this.getLocalizedText('Field_Required')}
                                        validateOn={form.guardianName}>
                                        <TextInput value={form.guardianName} alphabeticOnly
                                            onChange={(value) => this.fieldChanged('guardianName', value)} />
                                    </FormField>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-3 dim14-form-label">
                                    {this.getLocalizedText('Relationship_To_Patient')}
                                </div>
                                <div className="col-md-3 dim14-base-input">
                                    <FormField ref={formField => this.pushFormFieldRef(formField)}
                                        disabled={!isPatientMinor}
                                        required requiredMessage={this.getLocalizedText('Field_Required')}
                                        validateOn={form.guardianRelationship}>
                                        <TextInput value={form.guardianRelationship} alphabeticOnly
                                            onChange={(value) => this.fieldChanged('guardianRelationship', value)} />
                                    </FormField>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6 dim14-form-label">
                                    {this.getLocalizedText('Patient_Signature')}
                                </div>
                                <div className="col-md-6 dim14-form-label">
                                    {this.getLocalizedText('Provider_Signature')}
                                </div>
                            </div>
                        </div>

                        <div className="container">
                            <div className="row">
                                <div className="col-md-6">
                                    <FormField ref={formField => this.pushFormFieldRef(formField)}
                                        required requiredMessage={this.getLocalizedText('Signature_Required')}
                                        validateOn={form.patientSignature}>
                                        <SignatureInput signature={form.patientSignature}
                                            onClear={() => {
                                                if (form) {
                                                    this.fieldChanged('patientSignature', null)
                                                }
                                            }}
                                            onSave={(signature) => {
                                                if (form) {
                                                    this.fieldChanged('patientSignature', signature)
                                                }
                                            }} />
                                    </FormField>
                                </div>
                                <div className="col-md-6">
                                    <FormField ref={formField => this.pushFormFieldRef(formField)}
                                        validateOn={form.providerSignature}
                                        required requiredMessage="Provider Signature required">
                                        <SignatureDisplay signature={form.providerSignature} />
                                    </FormField>
                                </div>
                            </div>
                        </div>
                    </div>
                </Wizard.Page>

                <Wizard.Page onPrevious={() => this.formFields = []}>
                    <div style={{ margin: "20px 20px 20px 20px" }}>
                        <div style={{ border: "1px solid", borderRadius: "5px", padding: "30px" }}>
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-12">
                                        <p className="font-weight-bold">
                                            <u>{this.getLocalizedText('Official_Use_Only')}</u></p>
                                        <p className="font-weight-bold">
                                            {this.getLocalizedText('Witness_Statement_Header')}</p>
                                        <p><i>{this.getLocalizedText('Witness_Statement')}</i></p>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-3 dim14-form-label">
                                        {this.getLocalizedText('Witness_Name')}
                                    </div>
                                    <div className="col-md-9 dim14-base-input">
                                        <TextInput value={form.witnessName} alphabeticOnly
                                            onChange={(value) => this.fieldChanged('witnessName', value)} />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="col-md-6 dim14-form-label">
                                            {this.getLocalizedText('Witness_Signature')}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <SignatureInput signature={form.witnessSignature}
                                            onClear={() => {
                                                this.fieldChanged('witnessSignature', null)
                                            }}
                                            onSave={(signature) => {
                                                this.fieldChanged('witnessSignature', signature)
                                            }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Wizard.Page>
            </Wizard>
        );
    }
}